import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Avatar } from "../components/Avatar";
import { SectionTitle, EmptyState, Loader, Card } from "../components/ui-bits";
import { timeAgo } from "../lib/constants";
import { MessageCircle } from "lucide-react";

export default function Messages() {
  const nav = useNavigate();
  const [convs, setConvs] = useState(null);
  useEffect(() => { api.get("/conversations").then((r) => setConvs(r.data)); }, []);
  if (convs === null) return <Loader />;
  return (
    <div className="max-w-2xl mx-auto">
      <SectionTitle sub="Discute prix et collaborations.">Messages</SectionTitle>
      {convs.length === 0 ? (
        <EmptyState icon={MessageCircle} title="Aucune conversation" desc="Lance une discussion depuis une proposition." />
      ) : (
        <div className="space-y-2">
          {convs.map((c) => (
            <Card key={c.id} onClick={() => nav(`/app/messages/${c.id}`)} data-testid={`conversation-${c.id}`}
              className="p-3.5 flex items-center gap-3 cursor-pointer hover:border-violet-600/60 transition-colors">
              <Avatar user={c.other} size={46} />
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <p className="font-semibold truncate">@{c.other?.pseudo}</p>
                  <span className="text-[11px] text-zinc-500 shrink-0">{timeAgo(c.last_message_at)}</span>
                </div>
                <p className="text-sm text-zinc-400 truncate">{c.last_message || "Nouvelle conversation"}</p>
              </div>
              {c.unread > 0 && <span className="w-5 h-5 rounded-full bg-violet-500 text-[10px] font-bold flex items-center justify-center shrink-0">{c.unread}</span>}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
